"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestingOrder = exports.stepToKey = exports.TestTestingStep = exports.Step = exports.CompilationSteps = exports.CompilationStep = exports.QualitySteps = exports.QualityStep = exports.LintingSteps = exports.LintingStep = void 0;
const runtypes_1 = require("runtypes");
exports.LintingStep = (0, runtypes_1.Literal)("checkstyle").Or((0, runtypes_1.Literal)("ktlint"));
exports.LintingSteps = ["checkstyle", "ktlint"];
exports.QualityStep = (0, runtypes_1.Literal)("classSize")
    .Or((0, runtypes_1.Literal)("complexity"))
    .Or((0, runtypes_1.Literal)("features"))
    .Or((0, runtypes_1.Literal)("lineCount"))
    .Or((0, runtypes_1.Literal)("recursion"))
    .Or((0, runtypes_1.Literal)("executioncount"))
    .Or((0, runtypes_1.Literal)("memoryAllocation"))
    .Or((0, runtypes_1.Literal)("coverage"))
    .Or((0, runtypes_1.Literal)("extraOutput"));
exports.QualitySteps = [
    "classSize",
    "complexity",
    "features",
    "lineCount",
    "recursion",
    "executioncount",
    "memoryAllocation",
    "coverage",
    "extraOutput",
];
exports.CompilationStep = (0, runtypes_1.Literal)("checkInitialSubmission")
    .Or((0, runtypes_1.Literal)("templateSubmission"))
    .Or((0, runtypes_1.Literal)("compileSubmission"))
    .Or((0, runtypes_1.Literal)("checkCompiledSubmission"));
exports.CompilationSteps = [
    "checkInitialSubmission",
    "templateSubmission",
    "compileSubmission",
    "checkCompiledSubmission",
];
exports.Step = exports.CompilationStep.Or((0, runtypes_1.Literal)("partial"))
    .Or((0, runtypes_1.Literal)("checkExecutedSubmission"))
    .Or((0, runtypes_1.Literal)("testing"))
    .Or(exports.LintingStep)
    .Or(exports.QualityStep);
exports.TestTestingStep = exports.CompilationStep.Or((0, runtypes_1.Literal)("checkExecutedSubmission").Or((0, runtypes_1.Literal)("testTesting"))).Or(exports.LintingStep);
const stepToKey = (step) => {
    if (step === "executioncount") {
        return "executionCount";
    }
    else {
        return step;
    }
};
exports.stepToKey = stepToKey;
exports.TestingOrder = [
    "checkInitialSubmission",
    "templateSubmission",
    "compileSubmission",
    "checkstyle",
    "ktlint",
    "checkCompiledSubmission",
    "classSize",
    "complexity",
    "features",
    "lineCount",
    "partial",
    // execution
    "checkExecutedSubmission",
    "recursion",
    "executioncount",
    "memoryAllocation",
    "testing",
    "coverage",
    "extraOutput",
];
//# sourceMappingURL=steps.js.map